export type AiFeature =
  | 'CaseBrief'
  | 'VoiceToNote'
  | 'NoteSuggestions'
  | 'NoteRewrite'
  | 'ReportGeneration'
  | 'ReportAnalysis'
  | 'NoteSummary';

export type AiFeatureRequirement = AiFeature | AiFeature[] | 'Any';

export interface AiFeatureInfo {
  key: AiFeature;
  label: string;
  description: string;
}

export const AI_FEATURES: AiFeatureInfo[] = [
  { key: 'CaseBrief', label: 'Case AI Brief', description: 'Generate and ask questions about a case-level AI brief.' },
  { key: 'VoiceToNote', label: 'Voice to Note', description: 'Record audio and transcribe it into notes.' },
  { key: 'NoteSuggestions', label: 'Note Suggestions', description: 'AI analysis of a note with suggestions.' },
  { key: 'NoteRewrite', label: 'Note Rewrite', description: 'AI rewrite and proofread of the current note.' },
  { key: 'ReportGeneration', label: 'Report Generation', description: 'Synopsis and narrative reports and ITO grounds drafts.' },
  { key: 'ReportAnalysis', label: 'Report Analysis', description: 'AI Tools prompts over notebook text.' },
  { key: 'NoteSummary', label: 'Note Summary', description: 'AI drafting of note summaries.' },
];

export interface AiUserSettings {
  aiEnabled: boolean;
  disabledFeatures: AiFeature[];
}

export interface AiOrganizationSettings {
  aiEnabled: boolean;
  disabledFeatures: AiFeature[];
  allowUserAiOptOut: boolean;
}

export type AiSettingsLoadStatus = 'loading' | 'ready' | 'notAllowed' | 'error';

export interface AiSettingsView {
  enabledFeatures: AiFeature[];
  canManageOwn: boolean;
  user?: AiUserSettings | null;
  organization?: AiOrganizationSettings | null;
}

export function isAiFeatureEnabled(view: AiSettingsView | null | undefined, requirement: AiFeatureRequirement): boolean {
  if (!view || !Array.isArray(view.enabledFeatures)) return false;
  if (requirement === 'Any') return view.enabledFeatures.length > 0;
  if (Array.isArray(requirement)) return requirement.some((f) => view.enabledFeatures.includes(f));
  return view.enabledFeatures.includes(requirement);
}

export function hasAiSettingsTab(view: AiSettingsView | null | undefined): boolean {
  return !!view && (!!view.organization || !!view.user);
}

export function toggleFeature(disabled: AiFeature[], feature: AiFeature, enabled: boolean): AiFeature[] {
  const rest = disabled.filter((f) => f !== feature);
  return enabled ? rest : [...rest, feature];
}
